import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: any = {
  loading: false,
  error: null,
  vouchers: null,
  storeVoucher: null,
};
const vouchersSlice = createSlice({
  name: "vouchers-slice",
  initialState,
  reducers: {
    loadVouchersRequested(state, action: PayloadAction<{}>) {
      state.voucherLoading = true;
      state.error = null;
      state.vouchers = [];
    },
    loadVouchersSuccess(state, action: PayloadAction<any>) {
      state.voucherLoading = false;
      state.error = null;
      state.vouchers = action?.payload?.result?.results;
      state.paginationOption = {
        page: action.payload?.result?.page,
        pageSize: action.payload?.result?.pageSize,
        totalItems: action.payload?.result?.totalItems,
        numberOfPages: action.payload?.result?.numberOfPages,
      };
    },
    loadVouchersFail(state, action: PayloadAction<{}>) {
      state.voucherLoading = false;
      state.error = action.payload;
    },
    storeVoucherRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    storeVoucherSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.storeVoucher = action.payload;
    },
    storeVoucherFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
    updateVoucherRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    updateVoucherSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.updateVoucher = action.payload;
    },
    updateVoucherFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
    archiveVoucherRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    archiveVoucherSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.archiveVoucher = action.payload;
    },
    archiveVoucherFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
    storeCustomerVoucherRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    storeCustomerVoucherSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.storeCustomerVoucher = action.payload;
    },
    storeCustomerVoucherFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  loadVouchersRequested,
  loadVouchersSuccess,
  loadVouchersFail,
  storeVoucherRequested,
  storeVoucherSuccess,
  storeVoucherFail,
  updateVoucherRequested,
  updateVoucherSuccess,
  updateVoucherFail,
  archiveVoucherRequested,
  archiveVoucherFail,
  archiveVoucherSuccess,
  storeCustomerVoucherRequested,
  storeCustomerVoucherFail,
  storeCustomerVoucherSuccess,
} = vouchersSlice.actions;

export default vouchersSlice.reducer;
